exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label.radio[data-v-76426144]:first-of-type{margin-left:-10px}label.radio[data-v-76426144]:not(:first-of-type){margin-left:25px}", ""]);

// exports
